export default __webpack_public_path__ + "static/093-c144876894730223332fc6c5f100ed51.jpg";